import MainContainer from "../../components/container/MainContainer";

const SingleDonorReport = () => {
  return <MainContainer>SingleDonorReport</MainContainer>;
};

export default SingleDonorReport;
